export default __webpack_public_path__ + "static/media/ilus7.f22f7001.jpeg";